export const SHOW_MULTI_PDP_VISITS = 'SHOW_MULTI_PDP_VISITS';
export const SHOW_PDP_SOURCING = 'SHOW_PDP_SOURCING';
export const PDP_TRADE_REQUEST_APPOINTMENT_TOOLTIP = 'PDP_TRADE_REQUEST_APPOINTMENT_TOOLTIP';

export const PRIORITIES = {
    MULTI_PDP_VISITS: 345,
    PDP_SOURCING: 450,
    PDP_TRADE_REQUEST_APPOINTMENT_TOOLTIP: 346,
};

export const NOTIFICATION_KEYS = {
    MULTI_PDP_VISITS: 'multiPdpVisits',
    PDP_SOURCING_MODAL: 'pdpSourcingModal',
    PDP_TRADE_REQUEST_APPOINTMENT_TOOLTIP: PDP_TRADE_REQUEST_APPOINTMENT_TOOLTIP,
};
